import { Environment } from '../../../environment';
import { Api } from '../axiosApi';

export interface IListagemNcm {
  ncm: string;
  descricao: string;
}
type TNcmComTotalCount = {
  data: IListagemNcm[];
  totalCount: number;
}
const getAlllist = async (filter = '', id = ''): Promise<TNcmComTotalCount | Error> => {
  try {
    if (id != '') {
      filter = id;
    }
    const urlRelativa: string = filter === '' ? `/ncm?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/ncmlist/${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      // /ncmlist/:filter (usado quando `id` é passado, pra pré-carregar o NCM
      // já salvo no produto — ver AutoCompleteNcm.tsx) devolve um objeto único,
      // não uma lista — normaliza pra array, mesmo ajuste de CfopService.getAlllist.
      return {
        data: Array.isArray(data) ? data : [data],
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
export const NcmService = {
  getAlllist,
};
